import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Container } from 'react-bootstrap'
import { accountsContainer } from 'src/models'
import { ContractsListCard } from './ContractsListCard'

@observer
class ContractsList extends React.Component {
  @observable contractAccordionIndex = -1
  @observable isActive = false

  handleVisibility = props => {
    this.contractAccordionIndex = props.index
    this.isActive = props.isOpen
  }
  renderContractsList = (contract, index) => {
    const isActive =
      this.contractAccordionIndex === index ? this.isActive : false

    return (
      <ContractsListCard
        contract={contract}
        key={`contract-${index}`}
        index={index}
        isActive={isActive}
        handleVisibility={this.handleVisibility}
      />
    )
  }
  render() {
    const contractsData = accountsContainer?.contractsResponse?.contracts || []
    return (
      <Container className="p-0">
        {contractsData.map(this.renderContractsList)}
      </Container>
    )
  }
}

export { ContractsList }
